import { Breakpoints } from '@/hooks/useBreakpoint';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;

  gap: ${({ theme }) => theme.spacing[4]}px;
`;

export const ContainerTextos = styled.div<{ $breakpoint: Breakpoints }>`
  display: flex;
  flex-direction: column;

  ${({ theme, $breakpoint }) => {
    if ($breakpoint === 'desktop') return '';
    return css`
      padding-left: ${theme.spacing['4']}px;
    `;
  }}
`;

export const Descricao = styled.span`
  ${({ theme }) => {
    return css`
      font-size: ${theme.typography.font.size['2']}px;
      font-family: var(--font-${theme.typography.font.family.text});
      font-weight: ${theme.typography.font.weight.medium};
      line-height: ${theme.typography.font.line_height['2']}px;
      color: ${theme.colors.neutral.neutral_alpha['11']};
    `;
  }};
`;

export const Row = styled.div<{ $breakpoint: Breakpoints }>`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing[4]}px;

  ${({ theme, $breakpoint }) => {
    if ($breakpoint === 'desktop') return '';
    return css`
      padding: 0 ${theme.spacing[4]}px;
    `;
  }}
`;

export const ContainerMontarPlano = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  width: 300px;
  height: 160px;

  background-color: ${({ theme }) =>
    theme.color_scheme.dark.colors.indigo[1].value};
  border-radius: ${({ theme }) => theme.radius['4']}px;
`;

export const ContainerMontarPlanoInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  min-width: 280px;
  padding: ${({ theme }) => theme.spacing[4]}px;
  gap: ${({ theme }) => theme.spacing[4]}px;
`;
